import { useState } from "react";

import { useTranslation } from "react-i18next";

import { TRANSLATION_KEYS } from "shared/constants/translations";

export const useEmailValidation = (email: string) => {
    const { t } = useTranslation();
    const [emailErrorKey, setEmailErrorKey] = useState<string | null>(null);

    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{1,63}$/;
    const isEmailValid = regexEmail.test(email);

    const validateEmail = (e: any) => {
        const inputValue = e.target.value;

        if (inputValue && !regexEmail.test(inputValue)) {
            setEmailErrorKey(TRANSLATION_KEYS.authInvalidEmailFormat);
        }
    };

    const clearEmailError = () => setEmailErrorKey(null);

    return {
        isEmailValid,
        emailError: emailErrorKey ? t(emailErrorKey) : null,
        setEmailError: setEmailErrorKey,
        clearEmailError,
        validateEmail
    };
};
